import React from 'react';
import * as Yup from 'yup';
import { Grid, Typography } from '@mui/material';
import {
  SparkDropdown,
  SparkForm,
  SparkTextField,
} from 'sharedComponents/SparkForm';
import FieldSkeleton from 'sharedComponents/Skeleton/FieldSkeleton';
import Footer from '../Stepper/Footer';
import { DropdownOption } from 'types/common/DropdownOption';
import { SparkDatePicker } from 'sharedComponents/UI/SparkDatePicker';

export type PersonalOverviewFormValues = {
  dateofBirth: string;
  about: string;
  genderID: string;
};

type PersonalOverViewFormProps = {
  activeStep: number;
  nextStepHandler: () => void;
  previousStepHandler: () => void;
  overViewCollection?: PersonalOverviewFormValues;
  setOverViewCollection: (formValues: PersonalOverviewFormValues) => void;
  dropdownOptions: DropdownOption[];
};

function PersonalOverViewForm({
  nextStepHandler,
  activeStep,
  previousStepHandler,
  overViewCollection,
  setOverViewCollection,
  dropdownOptions,
}: PersonalOverViewFormProps) {
  const personalOverViewFormValidationSchema = Yup.object({
    dateofBirth: Yup.string().nullable(),
    genderID: Yup.number().required('Gender is Required'),
    about: Yup.string().max(1000, 'Max 1000 characters').nullable(),
  });

  const personalOverViewFormInitialValues = {
    dateofBirth: overViewCollection?.dateofBirth || '',
    genderID: overViewCollection?.genderID || '',
    about: overViewCollection?.about || '',
  };

  const handleSubmit = (values: PersonalOverviewFormValues) => {
    setOverViewCollection(values);
    nextStepHandler();
  };

  const isLoading = false;
  if (isLoading) {
    return <FieldSkeleton count={4} />;
  }

  return (
    <SparkForm
      initialValues={personalOverViewFormInitialValues}
      onSave={handleSubmit}
      validationSchema={personalOverViewFormValidationSchema}
    >
      <Grid item padding={2} paddingLeft={0}>
        <Typography
          fontFamily='Mont-regular'
          justifyContent='flex-start'
          sx={{ fontSize: '1.0rem' }}
        >
          Tell us more about yourself.
        </Typography>
      </Grid>
      <SparkDatePicker name='dateofBirth' label='Date of Birth' size={12} />
      <SparkDropdown
        name='genderID'
        label='Gender'
        children={dropdownOptions}
        size={12}
      />

      <SparkTextField
        name='about'
        label='About'
        rows={4}
        size={12}
        multiline={true}
        showCounter={true}
        maxNumber={1000}
      />
      <Footer
        activeStep={activeStep}
        handleBack={previousStepHandler}
        isLastStep={false}
      />
    </SparkForm>
  );
}

export default PersonalOverViewForm;
